import LoyaltyWhopperGuarantee from 'pages/loyalty/loyalty-whopper-guarantee/loyalty-whopper-guarantee';

export default function WhopperGuaranteeScreen() {
  return <LoyaltyWhopperGuarantee />;
}
